/* istanbul ignore file */
import React from 'react';
import { getPathnameFromUrl } from '@noths/polaris-client-utils';
import type { GetServerSideProps } from 'next';

import { Seo } from 'src/components/atoms/Seo/Seo';
import { HeroBanner } from 'src/components/molecules/HeroBanner/HeroBanner';
import { ReviewsPolicy } from 'src/components/molecules/ReviewsPolicy/ReviewsPolicy';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { getFeatureFlagsWithMatchers } from 'src/featureFlags/getFeatureFlagsWithMatchers';
import { fetchGlobalContent } from 'src/services/contentstack/fetchGlobalContent';
import * as styles from 'src/styles/reviews.styles';

const title = 'Not On The High Street reviews';

const Reviews = () => (
  <>
    <Seo
      description="Read tons of Not On The High Street reviews from genuine customers and find out what people are saying about our small biz marketplace…"
      title={title}
    />
    <div css={styles.container} id={SKIP_CONTENT_TARGET_ID}>
      <HeroBanner
        backgroundColor="#C4C0ED"
        headingLine1={title}
        imageAlt="heart-with-hands-image"
        imageHeight={100}
        imageWidth={200}
        images={[
          {
            src: 'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt6711778a79bb4057/68221b447a201b3c6ab1d34d/reviews-page-standard-banner-image.png',
            width: 200,
          },
        ]}
        subHeading={
          'Read reviews of our small brands and products from the people who know us best: our customers.'
        }
        textColorMode="dark"
      />

      <ReviewsPolicy />

      <div
        className="feefo-review-widget-service"
        css={styles.feefoWidgetContainer}
        id="feefo-service-review-widgetId"
      />
    </div>
    <script
      async
      src="https://api.feefo.com/api/javascript/notonthehighstreet-com"
      type="text/javascript"
    />
  </>
);

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const featureFlags = (req && getFeatureFlagsWithMatchers(req)) || {};
  const pathname = getPathnameFromUrl(req.url ?? '');
  const [siteChromeContent] = await fetchGlobalContent({
    featureFlags,
    urlPath: pathname,
  });

  return {
    props: {
      siteChromeContent,
    },
  };
};

export default Reviews;
